/**
 * Get correct classname for label based on label type from configuration
 *
 * @param styles - stylesheet module, e.g. import styles from './styles.module.scss'. Uses camelCase notation
 * @param labelType - label type from configuration. Uses kebab-case notation
 * @param fallbackClassName - fallback classname if labelType is not in styles
 *
 * @returns classname for label
 */
export const getLabelClassName = (
    styles: {
        [className: string]: string;
    },
    labelType: string | undefined,
    fallbackClassName?: string
): string => {
    if (labelType === undefined) {
        return '';
    }
    const availableClassNames = Object.keys(styles);
    const className = availableClassNames.includes(labelType) ? labelType : '';

    if (className && className in styles) {
        return styles[className];
    }

    if (fallbackClassName && fallbackClassName in styles) {
        return styles[fallbackClassName];
    }

    return '';
};
